<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background:#fff;">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form :inline="true" ref="form" :model="searchForm" class="demo-form-inline">
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                </el-form-item>
                 <el-form-item label="">
                  <el-input v-model="searchForm.phone" placeholder="手机"></el-input>
                </el-form-item>
                <el-form-item label="票类型：">
                  <el-select v-model="searchForm.ticketTypeId" placeholder="选择票类型">
                    <el-option
                      v-for="(type,index) in TicketType"
                      :label="type.name"
                      :key="index"
                      :value="type.ticketTypeId">
                      <div @click="getChangeType(type)">{{type.name}}</div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchSubmit()">搜索</el-button>
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button type="primary" plain icon="el-icon-plus" @click="addSubmit">新增</el-button>
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
          <el-table
            :data="dataList"
            height="100%"
            border
            class="tabbox"
            ref="multipleTable"
            :header-cell-style="{background:'#f2f6fc',color:'#606266'}"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="name" label="生成人员姓名" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="生成人员手机" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.remark}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="typeName" label="票类型" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.typeName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="生成数量" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.number}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="生成时间" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.createDate}}</span>
              </template>
            </el-table-column>
            <el-table-column label="下载文件" width="180" align="center">
              <template slot-scope="scope">
              <span>  <a target="_blank" :href="scope.row.url">查看</a></span>
              </template>
            </el-table-column>
            <el-table-column label="删除" width="180" align="center">
              <template slot-scope="scope">
                <el-button type="text" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table></div>
          <div class="fb"><el-pagination
            class="pag"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          ></el-pagination></div>
        </div>
        <DeleteDialog
          :delVisible="delVisible"
          @deleteData="deleteData"
          @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditMobleManage :editShow="editShow" :editData="editData" @backFunStu="getFunStu"></EditMobleManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditMobleManage from "../../../components/ticketing/ticket/EditMobleManage";
import TicketType from "../../../components/ticketing/ticket/TicketType";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pageSize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        name: "",
        phone: "",
        ticketTypeId:"",
        projectId:localStorage.getItem('project_Id')
      },
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      TicketType:[],
      ticketRecord_Id:''
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getTicketType();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
      this.getData();
    },
    addSubmit(){
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    searchSubmit() {
      this.getData();
    },
    handleDelete(index, row) {
      this.ticketRecord_Id = row.ticketRecordId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.ticketRecord_Id = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios.delete(`/TicketRecord/${this.ticketRecord_Id}`)
        .then(res =>{
            this.delVisible = false
          if (res.data.hasError == false) {
            this.$message.success("删除成功！");
            this.getData();
          }else{
            this.$message.error("删除失败！");
          }
        })
    },
    // 获取数据
    getData() {
      var search = {
        "name": this.searchForm.name,
        "pageIndex": this.currentPage - 1,
        "pageSize": this.pagesize,
        "ticketTypeId":this.searchForm.ticketTypeId==""?0:parseInt(this.searchForm.ticketTypeId) ,
        "phone": this.searchForm.phone,
        "projectId":this.searchForm.projectId,
        "type":3
      }
      this.$axios.post('/TicketRecord/Search',search).then(res =>{
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data]
          this.total = res.data.total;
        }
      })
    },
    getTicketType(){
      this.$axios.get('/TicketType/Project/'+this.searchForm.projectId).then(res =>{
        if (res.data.hasError == false) {
          this.TicketType = [...res.data.data]
        }
      })
    },
    getChangeType(type){
      this.searchForm.ticketTypeId = type.ticketTypeId;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    }
  },
  components: {
    EditMobleManage,
    DeleteDialog,
    TicketType
  }
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}
.el-main{
  border-radius: 5px;
  position: relative;
}
.uers-left {
  float: left;
}
.uers-right {
  float: right;
}
.el-dialog{
  height: auto;
}
</style>